import { render, staticRenderFns } from "./ParamGroupTable.vue?vue&type=template&id=1ac7d803&scoped=true"
import script from "./ParamGroupTable.vue?vue&type=script&lang=js"
export * from "./ParamGroupTable.vue?vue&type=script&lang=js"
import style0 from "./ParamGroupTable.vue?vue&type=style&index=0&id=1ac7d803&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac7d803",
  null
  
)

export default component.exports